import(/* webpackMode: "eager" */ "/app/diamond-ui/src/app/profile/page.tsx");
